export default {
  addInventory: null,
  inventoriesList: null,
  inventoryDetails: null,
  updateInventory: null,
  deleteInventory: null,
  deviceModalsList: null,
  inventoryMeta:null,
}